import React, { useMemo } from 'react';
import AdminMainContainer from 'components/admin/search/AdminMainContainer';
import { withGreyBackground } from 'pages/v2/WithGreyBackground';
import { useAdminLookup } from 'services/api/queries';
import { AdminLookupKeyEnum } from '../../../../types/types';
import AdminSearchFormPanel from '../../../../components/admin/search-epd/AdminSearchFormPanel';
import AdminSearchEpdResultsTable from '../../../../components/admin/search-epd/AdminSearchEpdResultsTable';
import { useEpdSearch } from './useEpdSearchHook';
import { useEpdSearchResultColumns } from './useEpdSearchResultColumns';
import { FieldPanelFullWidth, H1NewUI } from 'styles/v2/Styles.styled';

const AdminSearchEpd: React.FunctionComponent = () => {
  const { isLoading, searchResult, onSearch, pagination, onPageChange, updateAgentMutation } = useEpdSearch();

  const { data: licenseesLookup = [], isLoading: isLicenseesLookupLoading } = useAdminLookup(AdminLookupKeyEnum.LICENSEES);
  const { data: companiesLookup = [], isLoading: isCompaniesLookupLoading } = useAdminLookup(AdminLookupKeyEnum.COMPANIES);
  const { data: agentsLookup = [], isLoading: isAgentsLookupLoading } = useAdminLookup(AdminLookupKeyEnum.AGENTS);
  const { data: agentsOnEpdLookup = [], isLoading: isAgentsOnEpdLookupLoading } = useAdminLookup(
    AdminLookupKeyEnum.AGENTS_ON_EPD
  );

  const mergedAgentsLookup = useMemo(() => {
    const all = [...agentsLookup, ...agentsOnEpdLookup];
    const uniqueMap = new Map();
    for (const item of all) {
      if (!uniqueMap.has(item.value)) {
        uniqueMap.set(item.value, item);
      }
    }

    return Array.from(uniqueMap.values());
  }, [agentsLookup, agentsOnEpdLookup]);

  const agentsLookupWithEmpty = useMemo(() => {
    return [{ value: null, label: 'Unassigned' }, ...agentsLookup];
  }, [agentsLookup]);

  const columns = useEpdSearchResultColumns({
    agentsLookup: agentsLookupWithEmpty,
    mergedAgentsLookup,
    updateAgentMutation,
  });

  return (
    <AdminMainContainer>
      <H1NewUI>EPDs</H1NewUI>
      <AdminSearchFormPanel
        onSubmit={onSearch}
        isLoading={isLoading}
        companiesLookup={companiesLookup}
        licenseesLookup={licenseesLookup}
        mergedAgentsLookup={mergedAgentsLookup}
        isCompaniesLookupLoading={isCompaniesLookupLoading}
        isLicenseesLookupLoading={isLicenseesLookupLoading}
        isMergedAgentsLookupLoading={isAgentsLookupLoading || isAgentsOnEpdLookupLoading}
        isSearchComplete={!!searchResult}
      />

      {searchResult &&
        (searchResult.totalCount > 0 ? (
          <AdminSearchEpdResultsTable
            rows={searchResult.items}
            columns={columns}
            onPageChange={onPageChange}
            pagination={pagination}
            totalCount={searchResult.totalCount}
            isLoading={isLoading}
          />
        ) : (
          <FieldPanelFullWidth>No results found</FieldPanelFullWidth>
        ))}
    </AdminMainContainer>
  );
};

export default withGreyBackground(AdminSearchEpd);
